import { basePermissionManagerApi as api } from "../basePermissionManagerApi";
export const addTagTypes = ["Relations"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getRelations: build.query<GetRelationsApiResponse, GetRelationsApiArg>({
        query: (queryArg) => ({
          url: `/relations`,
          params: {
            resourceTypes: queryArg.resourceTypes,
          },
        }),
        providesTags: ["Relations"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as baseGeneratedApi };
export type GetRelationsApiResponse = unknown;
export type GetRelationsApiArg = {
  resourceTypes?: string[];
};
export const { useGetRelationsQuery } = injectedRtkApi;
